import { useEffect, useRef, useState } from "react";

import IconMount from "../components/IconMount";
import { PURPOSE } from "../data/content";
import { revealUp } from "../lib/motion";
import "./Purpose.css";

/**
 * Vision and mission.
 *
 * The reference floods each card solid blue on hover. That reads against the
 * light-premium direction, so the card keeps its light surface and answers with
 * a blue border, a lifted shadow and the icon's halo blooming instead.
 */
export default function Purpose() {
  const rootRef = useRef(null);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    const cards = rootRef.current?.querySelectorAll(".ilab-purpose__card");
    return revealUp([...(cards ?? [])], { y: 40, stagger: 0.12 });
  }, []);

  return (
    <section className="section ilab-purpose" ref={rootRef} aria-label="Vision and mission">
      <div className="container">
        <div className="ilab-purpose__grid">
          {PURPOSE.map(({ id, icon, title, body }) => (
            <article
              className="ilab-purpose__card"
              key={id}
              onMouseEnter={() => setHovered(id)}
              onMouseLeave={() => setHovered(null)}
              onFocus={() => setHovered(id)}
              onBlur={() => setHovered(null)}
            >
              <IconMount name={icon} tone="blue" size="md" active={hovered === id} />

              <div className="ilab-purpose__body">
                <h2 className="ilab-purpose__title">{title}</h2>
                <p>{body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
